import axios from "axios"

/**
 * Handles File-Uploads
 */
export default class UploadClient {
    constructor() {
        this.$http = axios.create({
            baseURL: process.env.VUE_APP_WOO_API_BASE_URL,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    /**
     * Upload a file to the wordpress project
     *
     * @param file
     * @returns {AxiosPromise<any>}
     */
    upload(file) {
        let form = new FormData()

        form.append('action', 'expivi_image_upload')
        form.append('file', file)

        return this.$http.post(process.env.VUE_APP_WOO_UPLOAD_URL, form)
    }
}
